import { render, staticRenderFns } from "./Project6.vue?vue&type=template&id=6c5cf638&scoped=true&"
import script from "./Project6.vue?vue&type=script&lang=js&"
export * from "./Project6.vue?vue&type=script&lang=js&"
import style0 from "./Project6.vue?vue&type=style&index=0&id=6c5cf638&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5cf638",
  null
  
)

export default component.exports